export const FeedbackMessageVariant = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
} as const;

export type FeedbackMessageVariantType =
  (typeof FeedbackMessageVariant)[keyof typeof FeedbackMessageVariant];

export const FeedbackMessageActionPosition = {
  RIGHT: 'right',
  BOTTOM: 'bottom',
} as const;

export type FeedbackMessageActionPositionType =
  (typeof FeedbackMessageActionPosition)[keyof typeof FeedbackMessageActionPosition];

export const FeedbackMessageMode = {
  INLINE: 'inline',
  GLOBAL: 'global',
} as const;

export type FeedbackMessageModeType =
  (typeof FeedbackMessageMode)[keyof typeof FeedbackMessageMode];

export type FeedbackMessageProps = {
  id?: string;
  testId?: string;
  distinctId: string;
  variant: FeedbackMessageVariantType;
  mode?: FeedbackMessageModeType;
  message: string;
  description?: string;
  linkText?: string;
  buttonText?: string;
  actionPosition?: FeedbackMessageActionPositionType;
  fullWidth?: boolean;
};
